import React from "react"
import { removeImageDescription } from "../utilities"
import DfbImage from "../ui-kit/dfb_image"
import DfbButton from "../ui-kit/dfb_button"
import CLightbox from '../elements/c_lightbox';
import DfbHeadline from "../ui-kit/dfb_headline"
import { Transformation } from "cloudinary-react";
import Section from "./section"

const MImagecarousel = props => {
  let modal_id = ''
  let show_lightbox = (props.show_lightbox ? props.show_lightbox : true)
  if (show_lightbox) {
    modal_id = `modal-uid-${props.data.uid}`
  }

  return (
    <Section
      baseClass="m-ImageCarousel"
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-ImageCarousel-wrapper">
        <div className="m-ImageCarousel-container">
          {props.data.headline && (
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h4"
              add_class="m-ImageCarousel-headline"
            />
          )}
          <div className="m-ImageCarousel-carousel">
            <div
              className="dfb-Slider m-ImageCarousel-slider"
              data-transition="slide"
              data-loop
              data-indicators
              data-drag
              data-controls
              role="region"
              tabIndex={0}
            >
              <div className="dfb-Slider-slider">
                <ul className="dfb-Slider-slides">
                  {props.data.imagecarousel.map((item, index) => (
                    <li key={index} className="dfb-Slider-slideItem">
                      <figure
                        className="m-ImageCarousel-figure"
                        data-toggle={(show_lightbox ? 'modal' : null)}
                        data-target={(show_lightbox ? `${modal_id}-${index}` : null)}
                      >
                        <DfbImage
                          image={item.imagecarousel_figure}
                          aspect_ratio="16:9"
                        >
                          <Transformation
                            crop="fill"
                            gravity="faces:center"
                            width="720"
                            height="405"
                            quality="auto"
                            fetchFormat="auto"
                          />
                        </DfbImage>
                        {item.imagecarousel_figure.description && (
                          <figcaption className="m-ImageCarousel-figcaption">
                            {item.imagecarousel_figure.description}
                          </figcaption>
                        )}
                      </figure>
                      { show_lightbox &&
                        <CLightbox
                          id={`${modal_id}-${index}`}
                          image={removeImageDescription(item.imagecarousel_figure)}
                          width="1600"
                          height="900"
                        >
                        </CLightbox>
                      }
                    </li>
                  ))}
                </ul>
              </div>
              <ul className="dfb-Slider-controls">
                <li className="dfb-Slider-controlElement dfb-Slider-controlElement--previous">
                  <DfbButton
                    tagName="button"
                    icon_type="Dropdown Left"
                    add_class="dfb-Slider-control dfb-Slider-control--previous"
                  />
                </li>
                <li className="dfb-Slider-controlElement dfb-Slider-controlElement--next">
                  <DfbButton
                    tagName="button"
                    icon_type="Dropdown Right"
                    add_class="dfb-Slider-control dfb-Slider-control--next"
                  />
                </li>
              </ul>
            </div>
          </div>
          <div className="m-ImageCarousel-counter">
            <span className="m-ImageCarousel-index" />/
            <span className="m-ImageCarousel-slideCount" />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MImagecarousel
